export default "__VITE_ASSET__9s3MbSZG__"